import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, permission }) {
  const { status, user, hasPermission } = useAuth();

  if (status === "loading") {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex items-center justify-center text-sm text-muted-foreground"
      >
        Loading…
      </div>
    );
  }
  if (status !== "authed" || !user) {
    return <Navigate to="/login" replace />;
  }
  if (permission && !hasPermission(permission)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
